<template>
  <div v-if="showForm">
    <div v-if="showPFLoader">
      <Loading instruction="Cancelling transaction..." />
      <timer
        v-if="canOpenMerchant"
        @time-over="callOpenMerchant"
        class="timer"
        :initialTime="cancelTimer"
        :immediate="showPFLoader"
      />
    </div>
    <div v-else>
      <app-header :is-show-info="false"></app-header>
      <div class="error-section-wrapper content-wrapper">
        <div :class="['error-content', computedClasses]">
          <img src="../assets/images/error.svg" alt="error" />
          <h3>Your transaction has been cancelled</h3>
          <p v-if="transactionError">{{ transactionError }}</p>

          <div class="buttons-wrapper">
            <cancel-button
              v-if="canOpenMerchant"
              :is-loading="isLoading"
              @click="callOpenMerchant"
            >
              Back to Merchant
            </cancel-button>
            <success-button
              v-if="canRetryTransaction"
              :is-loading="isRetryLoading"
              @click="retryTransaction"
            >
              Retry
            </success-button>
            <timer
              v-if="canOpenMerchant"
              @time-over="callOpenMerchant"
              class="timer"
              :initialTime="cancelTimer"
              :immediate="showPFLoader"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- The hidden form used when we post to the merchants URL -->
    <section style="display: none">
      <form method="post" action="" id="redirectForm" ref="redirectForm">
        <input type="hidden" name="SID_STATUS" value="" />
        <input type="hidden" name="SID_MERCHANT" value="" />
        <input type="hidden" name="SID_COUNTRY" value="" />
        <input type="hidden" name="SID_CURRENCY" value="" />
        <input type="hidden" name="SID_REFERENCE" value="" />
        <input type="hidden" name="SID_AMOUNT" value="" />
        <input type="hidden" name="SID_BANK" value="" />
        <input type="hidden" name="SID_DATE" value="" />
        <input type="hidden" name="SID_RECEIPTNO" value="" />
        <input type="hidden" name="SID_TNXID" value="" />
        <input type="hidden" name="SID_CUSTOM_01" value="" />
        <input type="hidden" name="SID_CUSTOM_02" value="" />
        <input type="hidden" name="SID_CUSTOM_03" value="" />
        <input type="hidden" name="SID_CUSTOM_04" value="" />
        <input type="hidden" name="SID_CUSTOM_05" value="" />
        <input type="hidden" name="SID_CONSISTENT" value="" />
      </form>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import Header from '@/components/Header'
import Timer from '@/components/Timer'
import CancelButton from '@/components/buttons/CancelButton'
import SuccessButton from '@/components/buttons/SuccessButton'
import { redirect } from '@/mixins/redirect'
import Loading from '@/components/Loading'

import Constants from '@/constants'
import { blockBackNavigationMixin } from '@/mixins/blockBackNavigationMixin'

export default {
  name: 'TransactionError',
  components: {
    'app-header': Header,
    Timer,
    CancelButton,
    SuccessButton,
    Loading,
  },
  mixins: [blockBackNavigationMixin, redirect],

  data() {
    return {
      isRetryLoading: false,
      isLoading: false,
      cancelTimer: Constants.cancelTimer,
    }
  },
  computed: {
    ...mapState('appSettings', ['transactionError', 'originalUrl']),
    ...mapState('transaction', ['transaction', 'showBodyOnly', 'hideContent']),
    ...mapState('merchantSettings', ['merchantReturnURL', 'merchantReturn']),
    ...mapGetters('merchantSettings', [
      'canRetryTransaction',
      'canOpenMerchant',
    ]),
    mailTo() {
      return Constants.mailto
    },
    transactionId() {
      return this.$route.query.transactionId
    },
    showForm() {
      return !this.hideContent
    },
    transactionStatus() {
      return (
        this.transaction &&
        this.transaction.status &&
        this.transaction.status.toUpperCase()
      )
    },
    computedClasses() {
      return {
        'no-shadow': this.showBodyOnly,
      }
    },
    showPFLoader() {
      return this.showBodyOnly && this.merchantReturn
    },
  },
  methods: {
    ...mapActions('merchantSettings', ['loadSettings']),
    ...mapActions('transaction', ['getTransaction', 'openMerchant']),
    async callGetTransaction() {
      try {
        await this.getTransaction({ transactionId: this.transactionId })
      } catch (error) {
        if (this.transactionId) {
          await this.$logError({
            transactionId: this.transactionId,
            message: 'Redirection error - reload transaction',
            stackTrace: error,
          })
        }
      }
    },

    retryTransaction() {
      this.isRetryLoading = true
      window.location = this.originalUrl
    },
  },
}
</script>

<style scoped lang="scss">
.error-section-wrapper {
  padding: 40px 64px;
  display: flex;
  justify-content: center;

  @media screen and (max-width: $mobile-resolution) {
    padding: 32px 16px;
  }
}
.error-content {
  box-shadow: 0px 5px 15px rgba(166, 166, 166, 0.3);
  border-radius: 8px;
  padding: 24px 60px;
  text-align: center;
  position: relative;
  width: 100%;

  @media screen and (max-width: $mobile-resolution) {
    padding: 24px;
  }

  .timer {
    position: absolute;
    bottom: 24px;
    left: 0;
    width: 100%;

    @media screen and (max-width: $mobile-resolution) {
      bottom: 0;
    }
  }

  .buttons-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 48px;

    @media screen and (max-width: $mobile-resolution) {
      margin-top: 10px;
      padding: 0;
    }
  }

  h3 {
    margin: 0;
    padding: 16px 0 24px 0;
  }

  p {
    margin: 0;
    font-weight: normal;
    font-size: 14px;
    line-height: 17px;
  }
}
</style>
